import React from "react";
import { useHistory } from "react-router-dom";

import ServiceHighlight from "../../components/ServiceHighlight";
import LogoLarge from "../../assets/logo_large_withtext.png";
import Hero from "../../assets/hero.jpg";
import ServiceImage0 from "../../assets/service_temp_0.jpg";
import ServiceImage1 from "../../assets/service_temp_1.jpg";
import ServiceImage2 from "../../assets/service_temp_2.jpg";
import styles from "./styles.module.scss";

const Home: React.FC = () => {
  const history = useHistory();

  const goToServices = () => {
    history.push("/services");
  };

  return (
    <>
      <div className={styles["hero-container"]}>
        <img className={styles["hero-background-image"]} src={Hero} alt="" />
        <div className={styles["hero-content"]}>
          <img src={LogoLarge} alt=""></img>
        </div>
      </div>
      <div className={styles.about}>
        <h1>Who are we?</h1>
        <p>
          MCP is a locally owned business that has been operating in Taupo for
          many years. We understand the importance of quality and reliable
          service to our customers. We specialise in placing and finishing
          concrete and our experienced crew at MCP aim to not only provide our
          customers with a safe, quality and efficient service, but also an
          exceptional end product.
        </p>
        <p>
          We are specialists in both commercial and residential placing and
          finishing. We can handle all you concreting needs from floor slabs and
          driveways to farm concrete and footpaths, and other concrete services.
          For more information contact MCP today or click here for a{" "}
          <b>free quote</b>.
        </p>
      </div>
      <div className={styles.services}>
        <h1>Services we provide</h1>
        <div className={styles.content}>
          <ServiceHighlight title="Residential" uri={ServiceImage0} />
          <ServiceHighlight title="Commercial" uri={ServiceImage1} />
          <ServiceHighlight title="Agricultural" uri={ServiceImage2} />
        </div>
        <button onClick={goToServices}>More information</button>
      </div>
    </>
  );
};

export default Home;
